
const validate = (props) => {
    const errors = {}

    if (!props.email) {
        errors.email = 'يرجي ادخال البريد الالكتروني'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(props.email)) {
        errors.email = 'البريد الالكتروني غير صحيح'
    }

    return errors
}

export default validate;